import { render, staticRenderFns } from "./selfExDialog.vue?vue&type=template&id=0889025e&scoped=true"
import script from "./selfExDialog.vue?vue&type=script&lang=js"
export * from "./selfExDialog.vue?vue&type=script&lang=js"
import style0 from "./selfExDialog.vue?vue&type=style&index=0&id=0889025e&prod&lang=scss"
import style1 from "./selfExDialog.vue?vue&type=style&index=1&id=0889025e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0889025e",
  null
  
)

export default component.exports